import { createContext, useContext, useState, ReactNode } from 'react';

interface AuthModalContextType {
    openAuthModal: boolean;
    openRegisterModal: boolean;
    isGoogleLogin: boolean;
    setOpenAuthModal: (open: boolean) => void;
    setOpenRegisterModal: (open: boolean) => void;
    handleOpenAuthModal: () => void;
    handleCloseAuthModal: () => void;
    handleOpenRegisterModal: () => void;
    handleCloseRegisterModal: () => void;
    handleSwitchToRegister: (isGoogle?: boolean) => void;
    handleSwitchToLogin: () => void;
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

export const AuthModalProvider = ({ children }: { children: ReactNode }) => {
    const [openAuthModal, setOpenAuthModal] = useState(false);
    const [openRegisterModal, setOpenRegisterModal] = useState(false);
    const [isGoogleLogin, setIsGoogleLogin] = useState(false);

    const handleOpenAuthModal = () => {
        setOpenAuthModal(true);
        setOpenRegisterModal(false);
    };

    const handleCloseAuthModal = () => {
        setOpenAuthModal(false);
    };

    const handleOpenRegisterModal = () => {
        setOpenRegisterModal(true);
        setOpenAuthModal(false);
    };

    const handleCloseRegisterModal = () => {
        setOpenRegisterModal(false);
        setIsGoogleLogin(false);
    };

    const handleSwitchToRegister = (isGoogle: boolean = false) => {
        setOpenAuthModal(false);
        setOpenRegisterModal(true);
        setIsGoogleLogin(isGoogle);
    };

    const handleSwitchToLogin = () => {
        setOpenRegisterModal(false);
        setOpenAuthModal(true);
        setIsGoogleLogin(false);
    };

    return (
        <AuthModalContext.Provider value={{
            openAuthModal,
            openRegisterModal,
            isGoogleLogin,
            setOpenAuthModal,
            setOpenRegisterModal,
            handleOpenAuthModal,
            handleCloseAuthModal,
            handleOpenRegisterModal,
            handleCloseRegisterModal,
            handleSwitchToRegister,
            handleSwitchToLogin
        }}>
            {children}
        </AuthModalContext.Provider>
    );
};

export const useAuthModal = () => {
    const context = useContext(AuthModalContext);
    if (context === undefined) {
        throw new Error('useAuthModal must be used within an AuthModalProvider');
    }
    return context;
};

export default AuthModalContext;
